import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router';

const useObtenerDestacados = () => {
    const [destacado, setDestacado] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const navigate = useNavigate();
    const [isNavigating, setIsNavigating] = useState(false);

    useEffect(() => {
        setDestacado([]);
        setLoading(false);

        return () => {
            setDestacado(null);
            setLoading(true);
            setError(null);
        };
    }, []);

    const irADetalles = (param, id) => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
        setIsNavigating(true);
        const id_replaced = id.replace(/ç/g, '');
        navigate(`/detalle?sku=${id_replaced}`, {
            state: {
                param,
                id
            }
        });
    }

    useEffect(() => {
        if (isNavigating) {
            setLoading(true);
            const timeoutId = setTimeout(() => {
                setLoading(false);
                setIsNavigating(false);
            }, 1000);
            return () => clearTimeout(timeoutId);
        }
    }, [isNavigating]);

    return { destacado, loading, error, irADetalles, isNavigating };
};

export default useObtenerDestacados;
